import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  EDIT_LOGIN_USER_DATA,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
}

const login = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      state = {
        ...state,
        loading: true,
        userData: action.payload,
      }
      break
    case LOGIN_SUCCESS:
      state = {
        ...state,
        loading: false,
        userData: action.payload,
      }
      break
    case LOGOUT_USER:
      state = { ...state, userData: {} }
      break
    case LOGOUT_USER_SUCCESS:
      state = { ...state, userData: {} }
      break
    case API_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
    case EDIT_LOGIN_USER_DATA:
      state = { ...state, userData: action.payload }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default login
